import { Action } from '@ngrx/store';
import { IFormConfiguration } from '../../../commons';

export enum FormConfigurationActionTypes {
  LoadFormConfigurationState = '[FormConfiguration] Load FormConfiguration State',
  LoadFormConfigurationStateSuccess = '[FormConfiguration] Load FormConfiguration State Success',
  SaveFormConfiguration = '[FormConfiguration] Save FormConfiguration',
  SaveFormConfigurationSuccess = '[FormConfiguration] Save FormConfigurationSuccess',
  LoadFormConfigurationStateFail = '[FormConfiguration] Load FormConfiguration State Fail',
  FormConfigurationScreenErrorReset = '[FormConfiguration] FormConfiguration Screen Error Reset'

}

export class LoadFormConfigurationState implements Action {
  readonly type = FormConfigurationActionTypes.LoadFormConfigurationState;
}

export class LoadFormConfigurationStateSuccess implements Action {
  readonly type = FormConfigurationActionTypes.LoadFormConfigurationStateSuccess;
  constructor(public payload: IFormConfiguration ) {}
}
export class SaveFormConfiguration implements Action {
  readonly type = FormConfigurationActionTypes.SaveFormConfiguration;
  constructor(public payload: IFormConfiguration ) {}
}
export class SaveFormConfigurationSuccess implements Action {
  readonly type = FormConfigurationActionTypes.SaveFormConfigurationSuccess;
}


export class LoadFormConfigurationStateFail implements Action {
  readonly type = FormConfigurationActionTypes.LoadFormConfigurationStateFail;
  constructor(public payload: any) {}
}

export class FormConfigurationScreenErrorReset implements Action {
  readonly type = FormConfigurationActionTypes.FormConfigurationScreenErrorReset;
}

export type FormConfigurationActions = 
  LoadFormConfigurationState
  | LoadFormConfigurationStateSuccess
  | SaveFormConfiguration
  | SaveFormConfigurationSuccess
  | LoadFormConfigurationStateFail
  | FormConfigurationScreenErrorReset;